/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_TitleInputs */

const en_onboarding_results_title = /** @type {(inputs: Onboarding_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result: you can read 2x to 3x faster`)
};

const es_onboarding_results_title = /** @type {(inputs: Onboarding_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado: puedes leer de 2x a 3x más rápido`)
};

/**
* | output |
* | --- |
* | "Result: you can read 2x to 3x faster" |
*
* @param {Onboarding_Results_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_title = /** @type {((inputs?: Onboarding_Results_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_title(inputs)
	return en_onboarding_results_title(inputs)
});